import { render, staticRenderFns } from "./OutpatientTables.vue?vue&type=template&id=27bcae19&scoped=true&"
import script from "./OutpatientTables.vue?vue&type=script&lang=js&"
export * from "./OutpatientTables.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientTables.vue?vue&type=style&index=0&id=27bcae19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bcae19",
  null
  
)

export default component.exports